/**
 * Initialize campaign fields
 */
const initialize = function() {
    $(document).on('change', '.form-group.select select', function() {
        let $form = $(this).closest('form');
        $form.find('[data-hide-on]').each(function() {
            let $elem  = $(this);
            let hideOn = $elem.data('hide-on');
            let hide   = false;
            hideOn.forEach(function(settings) {
                let $toggledBy = $form.find('[name^="fields[' + settings.field + '][input]"]:visible').first();
                // Field is only hidable if the toggle field is in the current step
                if ($toggledBy) {
                    let selectedValue = $toggledBy.val();

                    // If nothing is selected, hide
                    if (selectedValue === '' || selectedValue === null || ($.isArray(selectedValue) && selectedValue.length === 0)) {
                        hide = true;
                    } else if ($.isArray(selectedValue)) {
                        hide = hide || selectedValue.filter(function(value) {
                            return settings.values.indexOf(value) !== -1;
                        }).length > 0;
                    } else {
                        hide = hide || settings.values.indexOf(selectedValue) !== -1;
                    }
                }
            });
            $elem.toggle(!hide);
        });
    });
};

// Export defaults
export default {
    initialize: initialize,
}



// WEBPACK FOOTER //
// ./build/script/src/components/campaign_fields.js